export default __webpack_public_path__ + "static/media/default-avatar.41c95564.png";